import * as React from "react";

import { Header, Navigation, Footer } from "../../../shared";
import { AdministrationMenu } from "../../shared/menu/AdministrationMenu";
import { TableUsers } from "./TableUsers";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Tooltip,
  Typography,
  Paper,
  Switch,
  Snackbar,
  SnackbarContent
} from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import Rest from "../../../../services/Rest";

import "./UsersRegister.scss";
import * as md5 from "crypto-js/md5";
import * as sha512 from "crypto-js/sha512";
import { validatePassword } from "src/services/PasswordService";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

const QUERY_SAVE_USERS = ` query saveUserRegister($user:  BooksUserInput) { saveUserRegister(user: $user) { email,fullname,ssoid,id, isinternal,password,username } } `;

const QUERY_RESET_PASSWORD = ` query resetPassword($user:  BooksUserInput) { resetPassword(user: $user) } `;

// tslint:disable-next-line:no-empty-interface
export interface IUsersRegisterProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IUsersRegisterState {
  alertMessage: string,
  alertOpened: boolean,
  alertType: string,
  user: {
    email: string,
    password: string,
    fullname: string,
    username: string,
    id: number,
    isinternal: boolean,
    ssoid:string
  }
}

export class UsersRegister extends React.Component<IUsersRegisterProps, IUsersRegisterState> {

  private tableUsers: React.RefObject<TableUsers>;
  constructor(props: IUsersRegisterProps) {
    super(props);
    this.tableUsers = React.createRef();

    this.state = {
      alertMessage: '',
      alertOpened: false,
      alertType: 'success',
      user: {
        email: '',
        fullname: '',
        id: 0,
        isinternal: false,
        password: '',
        ssoid: '',
        username: ''
      }
    }

    this.searchUser = this.searchUser.bind(this);
    this.receiveUserToEdit = this.receiveUserToEdit.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
  }

  public receiveUserToEdit (user:any) {
    this.setState( {user} );
  }

  public resetPassword (user: any, newPassword: string) {
      if(newPassword!=null && newPassword!==undefined && newPassword !== "") {

        const validatePass = validatePassword(newPassword);
        if (validatePass) {
            this.errorSaveUser(validatePass);
            return;
        }
        const pass = this.cryptPass(newPassword);

        const userToSend : any = {
            "user" : {
                "id":user.id,
                "password": pass,
                "ssoid": user.ssoid
            }
        };

        const body = {
            "operationName":"",
            "query":QUERY_RESET_PASSWORD,
            "variables":userToSend
        };
    
        Rest.GraphqlPOST(body)
            .then( data  => {
                if(data && data.data && data.data.errors != null && data.data.errors !== undefined && data.data.errors.length > 0) {
                    this.errorSaveUser(data.data.errors[0].message);
                } else {
                    this.passwordSuccessReseted();
                    setTimeout(
                        this.searchUser(null), 3000
                    );
                }
            }).catch(err => {
                let errorMessage = 'Falha ao resetar senha.';
                if(err != null && err !== undefined && err.message !=null && err.message !== undefined && err.message !== "") {
                    errorMessage = err.message;
                }
                this.errorSaveUser(errorMessage);
            });
      } else {
          this.errorSaveUser("É necessário informar a nova senha");
      }
  }
  

  public render() {

    
    return (
      <div className="users-register-page">
        <Header title={"Cadastro de Usuários"} name={"Administrativo"} link={"/dashboard"} />

        <Navigation name={"Cadastro de Usuários"}
            linkDefault={"/administration/users-register"}
            link={"/dashboard"}
            linkTitle={"Produtos"}
            painel={3}
            icon={<ChevronRightIcon />}
        />
        
        <div className="users-register-body">
          <AdministrationMenu paramIcon={null} />

          <div className="wrapper">
            <Grid
              container={true}
              className="users-register-panel panel-grid"
              spacing={16}>

              <Grid item={true} xs={12} >
                <div>
                  <Paper className="analytical-panel">
                    <Grid container={true} direction="column" spacing={16}>
                      <Grid item={true}>
                        <Card>
                          <CardContent>

                            <Snackbar
                              anchorOrigin={{
                                horizontal: 'center',
                                vertical: 'center',
                              }}
                              open={this.state.alertOpened}
                              autoHideDuration={4000}
                              onClose={this.closeAlert}>
                              <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                            </Snackbar>
                              
                            <form>

                                <FormGroup row={true}>
                                    <TextField
                                        id="outlined-email-input"
                                        label="E-mail"
                                        style={this.textFieldStyle()}
                                        value={this.state.user.email}
                                        onChange={this.handleChangeCadastro('email')}
                                        type="email"
                                        name="email"
                                        autoComplete="email"
                                        margin="normal"
                                        className="formTextField"
                                        required={true}
                                    />

                                    {(this.state.user.id == null || this.state.user.id === undefined || this.state.user.id === 0) && <Tooltip disableHoverListener={true} title={
                                            <React.Fragment>
                                              <Typography color="inherit">Mínimo de 8 caracteres</Typography>
                                              <Typography color="inherit">1 letra maiúscula</Typography>
                                              <Typography color="inherit">1 letra minúscula</Typography>
                                              <Typography color="inherit">1 número</Typography>
                                              <Typography color="inherit">1 caracter especial</Typography>
                                            </React.Fragment>
                                        } placement="bottom-end">

                                        <TextField
                                            id="standard-password-input"
                                            label="Senha"
                                            value={this.state.user.password}
                                            onChange={this.handleChangeCadastro('password')}
                                            style={this.textFieldStyle()}
                                            type="password"
                                            autoComplete="current-password"
                                            margin="normal"
                                            className="formTextField"
                                            required={true}
                                          />
                                    </Tooltip>}
                                
                                    <TextField
                                        id="standard-fullname-input"
                                        label="Nome Completo"
                                        value={this.state.user.fullname}
                                        onChange={this.handleChangeCadastro('fullname')}
                                        style={this.textFieldStyle()}
                                        type="text"
                                        autoComplete="text"
                                        margin="normal"
                                        className="formTextField"
                                        required={true}
                                    />

                                    <TextField
                                        id="standard-username-input"
                                        label="Nome de Usuário"
                                        value={this.state.user.username}
                                        onChange={this.handleChangeCadastro('username')}
                                        style={this.textFieldStyle()}
                                        type="text"
                                        autoComplete="text"
                                        margin="normal"
                                        className="formTextField"
                                    />

                                    <FormControlLabel className="formSwitchField" label="Interno" control={
                                        <Switch
                                            checked={this.state.user.isinternal}
                                            onChange={this.handleChangeCadastro('isinternal')}
                                            value="user.isinternal"
                                            color="primary"
                                        />
                                      }
                                    />
                                </FormGroup>
                            </form>
                          </CardContent>
                          <CardActions>
                              <Button className="filter-dialog-clear" onClick={this.handleClearCadastro} >
                                  Limpar
                              </Button>
                              <Button className="filter-dialog-close" onClick={this.searchUser.bind(this,null)} color="primary">
                                  Pesquisar
                              </Button>
                              <Button className="filter-dialog-close" onClick={this.saveUser} color="primary">
                                  Salvar
                              </Button>
                          </CardActions>
                        </Card>
                        <Card>
                            <CardContent>
                                <TableUsers
                                    receiveUserToEdit={this.receiveUserToEdit}
                                    resetPassword={this.resetPassword}
                                    error={(msg) => this.openAlert(true, 'error', msg)}
                                    ref={this.tableUsers} />
                            </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Paper>
                        
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className="users-register-footer">
          <Footer />
        </div>
      </div>
    );
  }

    private alertStyle = () => {
        return styles[this.state.alertType];
    }

    private textFieldStyle = () => {
        return Object.assign({}, styles.textField)
    }

    private searchUser = (previewUser: any) => {
        if(this!= null && this.tableUsers != null && this.tableUsers.current != null) {

            let dataToSearch = previewUser;
            if(!dataToSearch) {
                dataToSearch = this.state.user;
            }

            this.tableUsers.current.changeState(dataToSearch);
        }
    }

    private validDataForSave = () => {
        let messageValidation = 'É obrigatório informar: ';

        if(!this.state.user.email) {
            messageValidation += " Email.";
        }

        if( (!this.state.user.id || this.state.user.id === 0) && !this.state.user.password) {
            messageValidation += " Senha.";
        }

        if(!this.state.user.fullname) {
            messageValidation += " Nome Completo.";
        }

        if(messageValidation !== 'É obrigatório informar: ') {
            this.errorSaveUser(messageValidation);
            return false;
        }

        return  true;
    }

    private saveUser = () => {
        if (this.validDataForSave()) {
            const userToSend : any = {
                "user" : {
                    "email": this.state.user.email,
                    "fullname": this.state.user.fullname,
                    "id": this.state.user.id,
                    "isinternal": this.state.user.isinternal,
                    "ssoid": this.state.user.ssoid,
                    "username": this.state.user.username
                }
            };

            if(!this.state.user.id || this.state.user.id === 0) {
                const validatePass = validatePassword(this.state.user.password);
                if (validatePass) {
                    this.errorSaveUser(validatePass);
                    return;
                }
                const pass = this.cryptPass(this.state.user.password);
                userToSend.user.password = pass;
            }

            const body = {
                "operationName":"",
                "query":QUERY_SAVE_USERS,
                "variables":userToSend
            };
        
            Rest.GraphqlPOST(body)
                .then( data  => {
                    if(data && data.data && data.data.errors != null && data.data.errors !== undefined && data.data.errors.length > 0) {
                        this.errorSaveUser(data.data.errors[0].message);
                    } else {
                        this.userSuccessSaved();
                        setTimeout(
                            this.searchUser(null), 3000
                        );
                    }
                }).catch(err => {
                    let errorMessage = 'Falha ao salvar registro.';
                    if(err != null && err !== undefined && err.message !=null && err.message !== undefined && err.message !== "") {
                        errorMessage = err.message;
                    }
                    this.errorSaveUser(errorMessage);
                });
        }
    }

    private userSuccessSaved() {
        this.openAlert(true, 'success', 'Cadastro realizado com sucesso.');
    }

    private errorSaveUser(msg: string) {
        this.openAlert(true, 'error', msg || 'Erro. Verifique se o email já existe e se a senha segue as regras para cadastro.');
    }

    private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
        this.setState({ alertType })
        this.setState({ alertMessage })
        this.setState({ alertOpened })
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }

    private handleChangeCadastro = (param: any) => (event: React.FormEvent<HTMLInputElement>) => {
        const user = Object.assign({}, this.state.user);
        if(param==="isinternal") {
            user[param] = !this.state.user.isinternal;
        } else {
            user[param] = event.currentTarget.value;
        }
        this.setState({ user });
    };

    private handleClearCadastro = () => {
        const user = {
            createdat: '',
            deletedat: '',
            email: '',
            fullname: '',
            id: 0,
            isinternal: false,
            password: '',
            ssoid: '',
            updatedat: '',
            username: ''
        };

        this.searchUser(user);

        this.setState({user});
    }

    private passwordSuccessReseted() {
        this.openAlert(true, 'success', 'Senha alterada com sucesso.');
    }

    private cryptPass = (pass: string) => {
        return sha512(md5(pass).toString().toUpperCase()).toString().toUpperCase();
    }
}


// WEBPACK FOOTER //
// ./src/component/administration/registers/users/UsersRegister.tsx